// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__Ghkjh","active":"header_active__K_Qcg","tab":"header_tab__wBXV6"};